import type { ChecklistTaskId } from "../types";

export type ChecklistTask = {
  id: ChecklistTaskId;
  title: string;
  blurb: string;
  /** Internal route (react-router Link) the CTA navigates to, if any. */
  href?: string;
  /** External URL (mobile stores) — opens a new tab and self-completes. */
  externalHref?: string;
  ctaLabel: string;
};

/**
 * What is left over once the rail has covered the guided run.
 *
 * These two are genuinely order-free — getting the mobile app has no business
 * blocking setting up an alert — which is exactly why they are here and not in
 * the rail. The four that were removed (squawk, watchlist, filter, popout) are
 * now rail steps; their ChecklistTaskIds survive in OnboardingState as the
 * durable "have they ever" record, they just have no row of their own.
 *
 * Every task links to where the action actually happens. An earlier version
 * pointed three of six at /guides anchors, which were then hidden from
 * non-internal users — leaving the only audience that sees this list looking at
 * tasks with no button at all.
 */
export const checklistTasks: ChecklistTask[] = [
  {
    id: "set_notification",
    title: "Set up an alert",
    blurb: "Get a pop-up or sound when a watchlist matches a headline.",
    href: "/settings",
    ctaLabel: "Open settings",
  },
  {
    id: "download_app",
    title: "Get the mobile app",
    blurb: "Squawk audio and alerts in your pocket.",
    externalHref: "https://apps.apple.com/us/app/newsquawk/id6759158115",
    ctaLabel: "Download",
  },
];
